import tenderResultNoticeValidation from "./resultNoticeValidation";

export const tenderResultNoticeValidationCast = tenderResultNoticeValidation().clone().transform((currentValues) => {
    const {
        orderObject,
        tenderCompletionData,
        offersData,
        contractorData,
        contractData,
    } = currentValues.form;

    if (orderObject && orderObject.partialOffers) {
        const tenderCompletionDataDivided = tenderCompletionData?.divided;
        const offersDataDivided = offersData?.divided;
        const contractorDataDivided = contractorData?.divided;
        const contractDataDivided = contractData?.divided;
        let transformedOffersDataDivided = offersDataDivided;
        let transformedContractorDataDivided = contractorDataDivided;
        let transformedContractDataDivided = contractDataDivided;

        if (Array.isArray(tenderCompletionDataDivided) && Array.isArray(offersDataDivided) && tenderCompletionDataDivided.length === offersDataDivided.length) {
            transformedOffersDataDivided = offersDataDivided.map((item, index) => {
                const tenderCompletionDataDividedElement = tenderCompletionDataDivided[index];
                return {
                    ...item,
                    correspondingTenderCompletionType: tenderCompletionDataDividedElement?.tenderCompletionType,
                };
            });
        }

        if (Array.isArray(tenderCompletionDataDivided) && Array.isArray(contractorDataDivided) && tenderCompletionDataDivided.length === contractorDataDivided.length) {
            transformedContractorDataDivided = contractorDataDivided.map((item, index) => {
                const tenderCompletionDataDividedElement = tenderCompletionDataDivided[index];
                return {
                    ...item,
                    correspondingTenderCompletionType: tenderCompletionDataDividedElement?.tenderCompletionType,
                };
            });
        }

        if (Array.isArray(tenderCompletionDataDivided) && Array.isArray(contractDataDivided) && tenderCompletionDataDivided.length === contractDataDivided.length) {
            transformedContractDataDivided = contractDataDivided.map((item, index) => {
                const tenderCompletionDataDividedElement = tenderCompletionDataDivided[index];
                return {
                    ...item,
                    correspondingTenderCompletionType: tenderCompletionDataDividedElement?.tenderCompletionType,
                };
            });
        }

        return {
            ...currentValues,
            form: {
                ...currentValues.form,
                offersData: {
                    ...offersData,
                    divided: transformedOffersDataDivided
                },
                contractorData: {
                    ...contractorData,
                    divided: transformedContractorDataDivided
                },
                contractData: {
                    ...contractData,
                    divided: transformedContractDataDivided
                }
            }
        };
    }

    return currentValues;
});